module.exports = __webpack_public_path__ + "static/Druk-Medium-c70c9cf55e21ea5931c104f6ea677db1.woff2";